import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Debtor/Main";
import Form from "./Debtor/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataDebtor } from "../../../model/InitialData/InitialDataDebtor";
import Navbar from "../../components/Modal/Navbar";

const Debtor = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataARtype, setDataARtype] = useState([]);
  const [dataSaleman, setDataSaleman] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataDebtor());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp("Tb_Set_AR", `ORDER BY AR_Code ASC`);
      const dataARtype = await getData(
        "Tb_Set_ARType",
        `1=1 AND Comp_Id = ${localStorage.getItem("company")}`
      );
      const dataListSaleman = await getDataWithComp(
        "Tb_Set_Employee",
        `AND Emp_Position = 4 ORDER BY Emp_Id`
      );

      console.debug("dataListSaleman", dataListSaleman);
      if (masterList && masterList.length > 0) {
        masterList.sort((a, b) => a.AR_Code.localeCompare(b.AR_Code));

        const masterWithTypeName = masterList.map((item) => {
          const matchedType = dataARtype.find(
            (type) => type.ARType_Id === item.AR_Type
          );
          return {
            ...item,
            ARType_Name: matchedType ? matchedType.ARType_Name : "", // ถ้าไม่เจอให้ใส่เป็นค่าว่าง
          };
        });
        // console.debug("masterWithTypeName", masterWithTypeName);
        setDataMasterList(masterWithTypeName);
      }
      if (dataARtype && dataARtype.length > 0) {
        setDataARtype(dataARtype);
      }
      if (dataListSaleman && dataListSaleman.length > 0) {
        setDataSaleman(dataListSaleman);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    console.debug("onRowSelected", item);
    setMode("U");
    setFormData({
      ar_id: item.Ar_Id,
      comp_id: window.localStorage.getItem("company"),
      ar_code: item.Ar_Code,
      ar_name: item.Ar_Name,
      ar_type: item.AR_Type,
      ar_shortname: item.Ar_ShortName,
      ar_taxno: item.Ar_TaxNo,
      ar_add1: item.Ar_Add1,
      ar_add2: item.Ar_Add2,
      ar_add3: item.Ar_Add3,
      ar_province: item.Ar_Province,
      ar_zipcode: item.Ar_Zipcode,
      ar_contact1: item.Ar_Contact,
      ar_contact2: item.Ar_Contact2,
      ar_tel1: item.Ar_Tel1,
      ar_tel2: item.Ar_Tel2,
      ar_group: item.Ar_Group,
      ar_refsalecode: item.Ar_RefSaleCode,
      ar_area: item.Ar_Area,
      ar_status: item.Ar_Status,
      ar_credit: item.Ar_Credit,
      ar_vat: item.Ar_Vat,
      ar_discount: item.Ar_Discount,
      ar_branch: item.Ar_Branch,
      ar_bt_name: item.Ar_BT_Name,
      ar_addlat: item.AR_ADDLAT,
      ar_addlan: item.AR_ADDLAN,
      ar_refsaleName: item.AR_RefSaleName,
      ar_credit_term: item.AR_Credit_Term,
      ar_credit_limit: item.AR_Credit_Limit,
      ar_refsalephone: item.AR_RefSalePhone,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลลูกหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลลูกหนี้"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataARtype={dataARtype}
                  dataSaleman={dataSaleman}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debtor;
